import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faEdit,
  faEye,
  faPersonDolly,
  faSplit,
  faBoxCircleCheck,
} from "@fortawesome/pro-regular-svg-icons";
import { faArrowLeftFromLine } from "@fortawesome/pro-duotone-svg-icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import LabelCount from "../../../components/ui/LabelCount";
import dayjs from "dayjs";
import OrderState from "../../../components/ui/OrderState";
import { useDispatch } from "react-redux";
import { removeBasket } from "../../../features/basket/basketSlice";
import PopoverMenu from "../../../components/ui/PopoverMenu";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";

function OrderListRow({ purchaseOrderKey, purchaseOrder, loadOrders, updateState })
{
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");
  const isOnlyUser = authUser?.user?.roles.includes("ROLE_USER") && !isAdmin;
  const { t } = useTranslation();

  const cancel = (order) => {
    Swal.fire({
      text: t("settings.orders.confirm_remove_basket"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.yes"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeBasket({ basket: order["@id"] })).then((response) => {
          if (loadOrders instanceof Function) {
            loadOrders();
          }
        });
      }
    });
  };

  return (
    purchaseOrder && (
      <>
        <div
          className={`grid ${
            isAdmin
              ? "grid-cols-5 lg:grid-cols-7"
              : "grid-cols-5 lg:grid-cols-5"
          } px-4 p-3 hover:bg-gray-50 ${
            purchaseOrderKey % 2 === 0 && "bg-gray-100"
          }`}
        >
          <div className="text-center flex items-center justify-center">
            <Link
              className="hover:underline"
              to={"/settings/orders/" + purchaseOrder.id}
            >
              {purchaseOrder.pieceNumber}
            </Link>
          </div>
          <div className="hidden lg:flex text-center items-center justify-center">
            {isAdmin && (
              <FontAwesomeIcon
                icon={
                  purchaseOrder.itemReceipt
                    ? faPersonDolly
                    : faArrowLeftFromLine
                }
                className={`ml-1 ${
                  !purchaseOrder.itemReceipt && "text-bioport-orange"
                }`}
                title={
                  purchaseOrder.itemReceipt
                    ? t("settings.orders.itemReceiptOn")
                    : t("settings.orders.itemReceiptOff")
                }
              />
            )}

            {isAdmin && purchaseOrder.splitable && (
              <FontAwesomeIcon
                icon={faSplit}
                className="ml-1"
                title={t("settings.orders.splitable")}
              />
            )}
          </div>

          <div className="text-center flex items-center justify-center">
            {dayjs(purchaseOrder.createdAt).format("DD/MM/YYYY")}
          </div>

          {isAdmin && (
            <div className="hidden lg:block flex items-center justify-center">
              <Link
                className="hover:underline"
                to={"/settings/partners/" + purchaseOrder.partner.id}
              >
                {purchaseOrder.partner.name}
              </Link>
            </div>
          )}
          <div className="text-center flex items-center justify-center">
            <LabelCount
              count={purchaseOrder.purchaseOrderItems.length}
              defaultClass="bg-gray-300"
              enabledClass="bg-bioport-blue text-white"
            />
          </div>
          <div className="text-center flex items-center justify-center">
            <OrderState
              order={purchaseOrder}
              className="px-2 py-1 text-xs font-normal"
            />
            
            {(isAdmin && purchaseOrder.state === "ready") && (
            <span className={`rounded ml-2 p-1 px-2 text-sm bg-gray-300 cursor-pointer hover:bg-bioport-blue hover:text-white`}>
                <FontAwesomeIcon
                  icon={faBoxCircleCheck}
                  data-tip
                  data-for={`purchaseOrderShipped${purchaseOrder.id}`}
                  onClick={(e) => updateState(purchaseOrder, 'shipped')}
                />
            </span>)}

            <ReactTooltip id={`purchaseOrderShipped${purchaseOrder.id}`} effect="solid">
              <span>{t("settings.orders.handleShipped")}</span>
            </ReactTooltip>
            
          </div>
          <div className="text-right flex items-center justify-end">
            {(isOnlyUser &&
              (purchaseOrder.state === "validated" ||
                purchaseOrder.state === "ready" ||
                purchaseOrder.state === "canceled")) ||
            (isAdmin && purchaseOrder.state === "ready") ? (
              <PopoverMenu
                links={[
                  {
                    link: "/settings/orders/" + purchaseOrder.id,
                    icon: faEye,
                    label: t("global.show"),
                    class:
                      "hover:cursor-pointer hover:underline text-bioport-blue",
                  },
                ]}
              />
            ) : (
              <PopoverMenu
                links={[
                  {
                    link: "/settings/orders/" + purchaseOrder.id,
                    icon: faEdit,
                    label: t("global.edit"),
                    class:
                      "hover:cursor-pointer hover:underline text-bioport-blue mb-2",
                  },
                  {
                    link: () => cancel(purchaseOrder),
                    icon: faTrashAlt,
                    label: t("global.form.delete"),
                    class: "hover:cursor-pointer hover:underline text-red-600",
                  },
                ]}
              />
            )}
          </div>
        </div>
      </>
    )
  );
}

export default OrderListRow;
